import React from 'react'
import { RowLayout } from '../RowLayout'
import { AttachmentListRespType, AttachmentType, TravelDataType } from '../../models'
import { strToDateFormat } from '../../helpers'
import { OverviewRowAttachments } from './OverviewRowAttachments'
import { translation } from '../../i18n'

type TripOverviewRespType = {
  tripData?: TravelDataType
  attachmentList: AttachmentListRespType[] | undefined
} & translation

export const TripOverview = (params: TripOverviewRespType) => {
  const t = params.t
  return (
    <>
      <RowLayout
        text={t('tripForm.travelType.label')}
        data={t(`tripForm.travelType.code.${params.tripData?.travelType}`)}
      />
      {params.tripData?.travelType === 'T' && (
        <RowLayout
          text={t('tripForm.touroperator.label')}
          data={params.tripData?.touroperator}
        />
      )}
      {params.tripData?.travelType === 'B' && (
        <RowLayout
          text={t('tripForm.companyName.label')}
          data={params.tripData?.companyName}
        />
      )}
      <RowLayout
        text={t('tripForm.insuredFrom.label')}
        data={strToDateFormat(params.tripData?.departureDate)}
      />
      <RowLayout
        text={t('tripForm.insuredTo.label')}
        data={strToDateFormat(params.tripData?.returnDate)}
      />
      <OverviewRowAttachments
        text={t('attachments.CASE.POLICY')}
        attachmentList={params?.attachmentList}
        attachmentType={AttachmentType.POLICY}
      />
    </>
  )
}
